const _excluded = ["label", "dataId", "isDisabled", "styles"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { MessageBarType } from 'office-ui-fabric-react';
import { useController } from 'react-hook-form';
import { Checkbox } from '../Checkbox';
import { MessageBar } from '../MessageBar';
import { Stack } from '../Stack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ControlledCheckbox = _ref => {
  let {
      label,
      dataId,
      isDisabled,
      styles
    } = _ref,
    controlProps = _objectWithoutProperties(_ref, _excluded);
  const {
    field: {
      onChange,
      value
    },
    fieldState: {
      error
    }
  } = useController(controlProps);
  return /*#__PURE__*/_jsxs(Stack, {
    styles: styles,
    children: [/*#__PURE__*/_jsx(Checkbox, {
      label: label,
      checked: !!value,
      onChange: (_ev, value) => {
        onChange(value || false);
      },
      dataId: dataId,
      disabled: isDisabled
    }), (error === null || error === void 0 ? void 0 : error.message) && /*#__PURE__*/_jsx(MessageBar, {
      messageBarType: MessageBarType.error,
      children: error.message
    })]
  });
};